<template>
  <div class="pc-search">
    <el-form class="pc-search-main-formOne" :model="keywordData" :inline="true">
      <el-form-item label="名称" class="title">
        <el-input
          v-model="keywordData.title_keywords"
          placeholder=""
        ></el-input>
      </el-form-item>
      <el-form-item label="年份" class="number">
            <el-date-picker
              v-model="keywordData.year"
              value-format="yyyy"
              type="year"
              placeholder="选择年份"
            >
            </el-date-picker>
      </el-form-item>
      <el-form-item label="状态" placeholder="状态" class="status">
        <el-select v-model="keywordData.status" placeholder="状态" clearable>
          <el-option label="有效" value="1">有效</el-option>
          <el-option label="无效" value="0">无效</el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <button class="pc-search-btn" @click="search">筛选</button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      keywordData: {
        title_keywords: "",
        status: null,
        year: "",
      },
    };
  },
  methods: {
    search() {
      this.$emit("search", this.keywordData);
    },
  },
};
</script>
<style lang="scss" scoped>
.pc-search {
  @include table-search;
  .title {
    width: 400px;
  }
  .number {
    width: 300px;
    /deep/ .el-input-number {
      width: 190px;
    }
  }
  .keyword {
    width: 400px;
    /deep/ .qh-tag {
      line-height: 24px;
    }
  }
  .teacher {
    width: 300px;
    /deep/ .el-autocomplete {
      width: 190px;
    }
  }
  .series {
    width: 320px;
  }
  .status {
    width: 200px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/guihua/components/MagazineSearch.vue